import { ReactElement } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { mainTheme } from 'shared/materialTheme';

const MaterialProvider = ({ children }: { children: ReactElement }): ReactElement => (
  <ThemeProvider theme={mainTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export default MaterialProvider;
